module.exports = __webpack_public_path__ + "img/yellowTheme.bf648d1c.png";